import { NodeSizeParams } from '../'
import { branch } from '../constants'

module.exports = (transaction) ->
  { className } = NodeSizeParams
  configNode = new Weaver.Node(className)
  configNode.set('name', className)
  await configNode.save({ transaction, branch, commitMessage: "Add Node Size Params Migration." })
  nodeSizeParams = new NodeSizeParams()
  await nodeSizeParams.reset({ transaction })
